import { render, staticRenderFns } from "./TagDirectory.vue?vue&type=template&id=0943c9d0"
import script from "./TagDirectory.vue?vue&type=script&lang=js"
export * from "./TagDirectory.vue?vue&type=script&lang=js"
import style0 from "./TagDirectory.vue?vue&type=style&index=0&id=0943c9d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports